<template>
  <div>
    <v-progress-linear
      :active="progressActive"
      :indeterminate="progressIndeterminate"
      color="primary"
      background-color="secondary"
      class="progressbar"
      :height="progBarHeight"
    >
    </v-progress-linear>
    <v-card
      flat
      class="actors-headline"
    >
      <v-card-title>
        <div>{{ activeActors.headline }}:</div>
        <div class="actor-category">{{ activeActors.label }}</div>
      </v-card-title>
      <v-card-actions>
        <v-btn
          icon
          @click="switchActorArray(-1)"
        >
          <font-awesome-icon class="icon" :icon="['fas', 'angle-left']" />
        </v-btn>
        <v-btn
          icon
          @click="switchActorArray(1)"
        >
          <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      flat
      class="list-container"
      :max-height="maxHeight"
    >
      <template>
        <slot
          v-for="i in activeActors.data"
          :actor="i"
        ></slot>
      </template>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'fact-sheet-actors',
  props: ['activeActors', 'maxHeight', 'progressActive', 'progressIndeterminate', 'progBarHeight'],
  methods: {
    switchActorArray (val) {
      this.$emit('click:actor', val)
    }
  }
}
</script>

<style scoped lang="css">
  .progressbar {
    margin: 0;
  }
  .actors-headline {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    margin: 8px;
  }
  .actors-headline .v-card__title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
  }
  .actors-headline .v-card__actions {
    padding: 4px;
  }
  .actors-headline .actor-category {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/FactSheet_Actors.vue